
import { validationMixin } from "vuelidate";
import LinkData, { LinkDataRequired } from "./LinkData";
import { mapGetters } from "vuex";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import Quest from "vue-material-design-icons/AccountQuestion.vue";

export default {
  name: "app-link-form",
  props: {
    url: {
      type: String,
    },
    link: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      configMoney: settingMoney,
      parcelas: [
        {
          id: 1,
          descricao: "À vista",
        },
        {
          id: 2,
          descricao: "Até 2x sem juros",
        },
        {
          id: 3,
          descricao: "Até 3x sem juros",
        },
        {
          id: 4,
          descricao: "Até 4x sem juros",
        },
        {
          id: 5,
          descricao: "Até 5x sem juros",
        },
        {
          id: 6,
          descricao: "Até 6x sem juros",
        },
        {
          id: 7,
          descricao: "Até 7x sem juros",
        },
        {
          id: 8,
          descricao: "Até 8x sem juros",
        },
        {
          id: 9,
          descricao: "Até 9x sem juros",
        },
        {
          id: 10,
          descricao: "Até 10x sem juros",
        },
        {
          id: 11,
          descricao: "Até 11x sem juros",
        },
        {
          id: 12,
          descricao: "Até 12x sem juros",
        },
      ],
    };
  },
  validations: {
    form: LinkDataRequired,
  },
  watch: {
    link(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  components: {
    Money,
    Quest,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  methods: {
    async getDataInit() {
      this.form = await new LinkData({});
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_grupo"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        if (!this.form.vezes) {
          this.$toast.warning("Selecione a quantidade de parcelas!");
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        this.form.data_expiracao =
          this.form.data_expiracao + " " + this.form.hora;

        await this.$http.post(this.url, this.form);

        this.$router.push({ name: "linksLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
